import $ from 'jquery';

const galleryThumbArrows = {
  prevArrow:
    "<button type='button' data-role='none' class='slick-prev icon-angle-left'><span class='visuallyHidden'>Previous</span></button>",
  nextArrow:
    "<button type='button' data-role='none' class='slick-next icon-angle-right'><span class='visuallyHidden'>Next</span></button>",
};

export const setupCarousels = (): void => {
  $('*[data-slick]').slick();

  $('.rotator').each(function initRotator(this: HTMLElement) {
    $(this).slick({
      slidesToShow: 1,
      arrows: false,
      lazy: 'progressive',
      touchThreshold: 5000,
    });
  });

  $('.photo-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    arrows: false,
    asNavFor: '.photo-gallery-thumbs',
  });

  $('.photo-gallery-thumbs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.photo-gallery',
    centerMode: true,
    focusOnSelect: true,
    ...galleryThumbArrows,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          asNavFor: '.photo-gallery',
          centerMode: true,
          focusOnSelect: true,
          ...galleryThumbArrows,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: '.photo-gallery',
          centerMode: true,
          focusOnSelect: true,
          ...galleryThumbArrows,
        },
      },
    ],
  });

  $('.interior-top .social-icons').affix({
    offset: {
      top: 200,
    },
  });
};
